import { getPresentationFiltersFn } from "../common/openapi";

import type { UseFullQueryOptions } from "./react-query";

export const queryPresentationFilters = ((presentationOrViewUrn) => ({
	queryKey: ["presentation-filters", presentationOrViewUrn] as const,
	queryFn: () => getPresentationFiltersFn({ presentationOrViewUrn }),
})) satisfies (presentationOrViewUrn: string) => UseFullQueryOptions;
